// extracted by mini-css-extract-plugin
export default {"box":"CustomIcon_box__e4yrd","icon":"CustomIcon_icon__yx-zb","fill":"CustomIcon_fill__K6MWc","stroke":"CustomIcon_stroke__mI4io","noDrop":"CustomIcon_noDrop__V-Kou"};